/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { SessionRead } from '../../models/session-read';

export interface GetSessionsApiV1SessionGet$Params {
}

export function getSessionsApiV1SessionGet(http: HttpClient, rootUrl: string, params?: GetSessionsApiV1SessionGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<SessionRead>>> {
  const rb = new RequestBuilder(rootUrl, getSessionsApiV1SessionGet.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<SessionRead>>;
    })
  );
}

getSessionsApiV1SessionGet.PATH = '/api/v1/session';
